import { Component } from '@angular/core';
import { FeedbackPlatformNominationResponseEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Nomination Responses') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-feedbackplatformnominationresponse-form',
    templateUrl: './feedbackplatformnominationresponse.form.component.html'
})
export class FeedbackPlatformNominationResponseFormComponent extends BaseFormComponent {
    public record!: FeedbackPlatformNominationResponseEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

